import type { QueryClient } from '@tanstack/react-query';

/**
 * #111: Ein Testfall hat im Katalog viele Spiegel im react-query-Cache (Detail, Baum, Prozess-
 * Listen, „Ohne Prozess", gefilterte Volliste, Zuordnungsseite). Diese eine Liste ersetzt die
 * mehrfach kopierten Blöcke, damit ein neuer Cache-Schlüssel nicht an einer Stelle vergessen wird.
 *
 * - `testCaseId` fehlt → alle Details des Projekts (`['tc', p]`-Präfix), z. B. nach einem
 *   Sammellauf, der viele Testfälle zugleich ändert.
 * - `processId` fehlt → alle Prozess-Listen (`['tcs', p]`-Präfix) statt nur der eines Prozesses.
 */
export function invalidateCatalogTestCase(
  queryClient: QueryClient,
  projectId: string,
  testCaseId?: string,
  processId?: string | null,
): void {
  const keys: unknown[][] = [
    testCaseId ? ['tc', projectId, testCaseId] : ['tc', projectId],
    ['catalog-tree', projectId],
    processId ? ['tcs', projectId, processId] : ['tcs', projectId],
    ['tcs-without-process', projectId],
    // #143: Der gefilterte Baum liest seine Zeilen aus der Volliste — sie muss mitziehen, sonst
    // bleibt ein Testfall nach dem Nachtragen der Übersetzung im Filter „fehlende Übersetzung".
    ['tcs-search', projectId],
    // #153: Die Zuordnungsseite zeigt dieselbe Detailansicht als Seitenleiste neben ihrer Liste.
    ['catalog-testcases', projectId],
  ];
  for (const queryKey of keys) void queryClient.invalidateQueries({ queryKey });
}
